import React, {useCallback, useEffect, useState} from 'react'
import {useParams} from "react-router";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import {makeStyles} from "@material-ui/styles";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import {connect} from "react-redux";
import Loading from "components/Loading";
import Button from "components/Button";
import Tr from "translations/Translations";
import AddNewOpinionMemberPopup from "./components/AddNewOpinionMemberPopup";
import BasicSearch from "components/BasicSearch";
import OpinionElement from "./components/OpinionElement";
import GridBlock from "components/GridBlock";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import AddIcon from "@material-ui/icons/AddBoxOutlined";
import DemandValidationMessages from "components/DemandValidationMessages";
import RouterPath from "libs/RouterPath";
import {PurchasingGroupRole} from "../../../constants/PurchasingGroupRole";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    search: {
        marginBottom: theme.spacing(2)
    }
}))

function PurchasingGroupStage1Opinion(
    {
        panelRef,
        validationSection,
        purchasingGroupHeader,
        opinions
    }) {
    const classes = useStyle();
    const params = useParams();
    const groupId = params.id;
    const stage = params.stage;
    const formId = params.section;
    const editable = validationSection.editable;
    const apiPathType = stage === "1" ? "AGREEMENT" : "SWZ"
    const coordinatorView = purchasingGroupHeader.userRole === PurchasingGroupRole.MEMBER;
    const [newOpinionPopup, setNewOpinionPopup] = useState(false);
    const [search, setSearch] = useState({});

    useStepperStateCloseValidator(formId);

    const closeSection = useCallback(() => RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {
        id: groupId,
        stage: stage
    })), [groupId, stage]);

    useEffect(() => {
        PurchasingGroupSectionService.getSections(groupId, validationSection.section)
        PurchasingGroupStage1Service.getOpinions(groupId, apiPathType).then((resp) => {
            if(!resp) closeSection();
        })
        return () => {
            PurchasingGroupStage1Service.clearResources(PurchasingGroupStage1Service.PURCHASING_GROUP_OPINIONS_RESOURCE_ID);
        }
    }, [groupId, closeSection, apiPathType, validationSection.section])

    if (!opinions) return <Loading/>

    return (<div className={classes.root}>
        <DemandValidationMessages editable={validationSection.editable} section={validationSection}/>
        {!coordinatorView && <GridBlock className={classes.search} justify="space-between">
            <BasicSearch className={classes.search} doSearch={setSearch} label={Tr('search_member')}/>
            <Button Icon={AddIcon} disabled={!editable} onClick={() => setNewOpinionPopup(true)}>{Tr("purchasing_group_add_new_opinion")}</Button>

        </GridBlock>
        }

        {
            opinions.map((x, i) => (
                <OpinionElement
                    key={x.identity}
                    groupId={groupId}
                    index={i}
                    opinion={x}
                    search={search}
                    coordinatorView={coordinatorView}
                    editable={editable}
                    apiPathType={apiPathType}
                />))
        }

        {(newOpinionPopup) && <AddNewOpinionMemberPopup groupId={groupId} onClose={() => setNewOpinionPopup(false)} apiPathType={apiPathType}/>}
    </div>)
}

PurchasingGroupStage1Opinion.propTypes = {}

export default connect((state) => ({
    opinions: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_OPINIONS_RESOURCE_ID],
    purchasingGroupHeader: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID]
}), {})(PurchasingGroupStage1Opinion);